import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CYCLE_CONSTANTS } from './Constants';
import { css } from 'emotion';

const styles = {
    container: css({
        minWidth: '200px',
        maxWidth: '300px'
    }),
    select: css({
        width: '100%',
        padding: '8px 12px',
        borderRadius: '4px',
        border: '1px solid #d5dbdb',  // Meridian-like border color
        fontSize: '14px',
        backgroundColor: '#fff',
        cursor: 'pointer',
        appearance: 'none',  // Remove default styling
        '-webkit-appearance': 'none',
        '-moz-appearance': 'none',
        backgroundImage: `url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22%23444%22%20d%3D%22M7.41%208.59L12%2013.17l4.59-4.58L18%2010l-6%206-6-6%201.41-1.41z%22%2F%3E%3C%2Fsvg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 8px center',
        backgroundSize: '16px',
        '&:hover': {
            borderColor: '#879596',  // Darker border on hover
        },
        '&:focus': {
            outline: 'none',
            borderColor: '#0073bb',  // Meridian blue
            boxShadow: '0 0 0 2px rgba(0, 115, 187, 0.2)'  // Meridian focus ring
        }
    }),
    label: css({
        display: 'block',
        marginBottom: '8px',
        fontSize: '14px',
        fontWeight: '500',
        color: '#16191f'  // Meridian text color
    }),
    wrapper: css({
        position: 'relative',
        width: '100%'
    })
};

const CycleSelector = ({ onChange, className }) => {
    const [selectedValue, setSelectedValue] = useState(() => {
        const stored = localStorage.getItem(CYCLE_CONSTANTS.STORAGE_KEY);
        return stored || 'CYCLE_1';
    });

    const handleChange = (event) => {
        const newValue = event.target.value;
        setSelectedValue(newValue);
        localStorage.setItem(CYCLE_CONSTANTS.STORAGE_KEY, newValue);
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <div className={`${styles.container} ${className || ''}`}>
            <div className={styles.wrapper}>
                <select 
                    className={styles.select}
                    value={selectedValue}
                    onChange={handleChange}
                >
                    {CYCLE_CONSTANTS.DEFAULT_CYCLES.map(cycle => (
                        <option key={cycle.value} value={cycle.value}>
                            {cycle.label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

CycleSelector.propTypes = {
    onChange: PropTypes.func,
    className: PropTypes.string
};

// Function to get current cycle
export const getCurrentCycle = () => {
    const stored = localStorage.getItem(CYCLE_CONSTANTS.STORAGE_KEY);
    return stored || CYCLE_CONSTANTS.DEFAULT_CYCLES[0].value;
};
CycleSelector.getCurrentCycle = getCurrentCycle;

export default CycleSelector;
